import React, { useCallback, useLayoutEffect, useRef } from 'react';

const MIN_FONT_PX = 9;
const MAX_FONT_PX = 14;

export const FittingFilterButtonLabel: React.FC<{
  icon: React.ReactNode;
  text: string;
}> = ({ icon, text }) => {
  const rowRef = useRef<HTMLDivElement>(null);
  const textRef = useRef<HTMLSpanElement>(null);

  const fit = useCallback(() => {
    const textEl = textRef.current;
    if (!textEl) return;
    let size = MAX_FONT_PX;
    textEl.style.fontSize = `${size}px`;
    while (size > MIN_FONT_PX && textEl.scrollWidth > textEl.clientWidth) {
      size -= 0.5;
      textEl.style.fontSize = `${size}px`;
    }
    if (size <= MIN_FONT_PX && textEl.scrollWidth > textEl.clientWidth) {
      textEl.style.textOverflow = 'ellipsis';
    } else {
      textEl.style.textOverflow = 'clip';
    }
  }, []);

  useLayoutEffect(() => {
    fit();
  }, [fit, text]);

  useLayoutEffect(() => {
    const row = rowRef.current;
    if (!row || typeof ResizeObserver === 'undefined') return;
    const ro = new ResizeObserver(() => fit());
    ro.observe(row);
    return () => ro.disconnect();
  }, [fit]);

  return (
    <div
      ref={rowRef}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: 10,
        flex: 1,
        minWidth: 0,
        overflow: 'hidden',
        textAlign: 'left',
      }}
    >
      {icon}
      <span
        ref={textRef}
        style={{
          flex: 1,
          minWidth: 0,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          lineHeight: 1.2,
          fontWeight: 400,
          textAlign: 'left',
        }}
      >
        {text}
      </span>
    </div>
  );
};
